<div class="hf-selector">
  <label *ngIf="label">{{ label }}</label>

  <div
    class="hf-selector-container hf-selector-has-value"
    [class.readonly]="readonly"
    [class.hf-selector-black-color]="!!value"
    [class.isInvalid]="isInvalid"
  >
    <div class="hf-selector-label-area">
      <div class="title">
        {{ value }}

        <ng-container *ngIf="!value">
          {{ placeholder }}
        </ng-container>
      </div>
    </div>
    <div class="hf-selector-actions">
      <button
        *ngIf="showClearButton"
        type="button"
        class="selector-clear"
        aria-label="Clear selected filter"
        (click)="onClearClicked($event)"
      >
        <i class="material-icons">close</i>
      </button>
      <i class="material-icons chevron-icon">chevron_right</i>
    </div>
  </div>
</div>
